<template>
    <div class="header flex_box">
        <div class="left" style="display: flex;align-items: center;">
            <a href="../">
            <svg-icon icon-class="icon" class-name="icon-icon"  alt="Icon" style="margin-right:7px;"/>
            <span>{{$t('header.title')}}</span></a>
            <!-- <span class="vertical" style="margin: 0 10px;color: #aaa;">|</span><a class="back_btn" href="https://www.aiseesoft.com/image-upscaler/">Back</a> -->
        </div>
        <div class="right">
            <span class="upgrde" @click="showPricingPop">
                <!-- <i></i> -->
                <svg-icon icon-class="upgrade" class-name="upgrade"/>
            <span>{{$t("btn.tips_upgrade")}}</span></span>
            <!--  -->
             <!-- @click="history" -->
            <span class="history">
                <svg-icon icon-class="history" class-name="history-svg"/>
                <!-- <i></i> -->
                <span>{{$t("btn.history")}}</span>
            </span>
            <span class="login" @click="loginFn">
                <!-- <i></i> -->
                <svg-icon icon-class="login" class-name="login-svg"/>
                <span v-show="!islog">{{$t("btn.login")}}</span>
            </span>
            <div class="photo_rights">
                <p class="info">
                    <span><i class="num">{{num}}</i> {{$t('header.hd')}}</span>
                    {{$t('header.watermarks')}}
                    <!-- https://account.aiseesoft.com -->
                    <a :href="url" target="_blank">{{$t('header.view_details')}}&gt;&gt;</a>
                </p>
                <a href="javascript:void(0);"  @click="showPricingPop" class="btn upgrade_btn">{{$t("btn.tips_upgrade")}}</a>
            </div>
            <div class="photo_rights_load">
                <!-- <img class="load" src="../assets/load.svg" alt="Load" /> -->
                <svg-icon icon-class="load" class-name="load"  alt="Load"/>
                <p>{{$t('header.loading')}}</p>
            </div>
        </div>
        <History @showPricingPop="showPricingPop"/>
        <Pricing :showmodule="showmodule" @closePricingPop="closePricingPop"/>
        
    </div>
</template>
<script>
import utils from '@/js/utils.js';
import Pricing from "@/components/pricing"
import History from "@/components/history"
export default {
    components:{
        Pricing,
        History,
    },
    props:{
        showupgrade:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return {
            showmodule:false,
            islog:false,
            isUpgradeTip:false,
            num:0,
            url:'',
        }
    },
    mounted(){
        var user=utils.getCookie('user');
        if(user){
            this.islog=true;
        }else{
            $('.maskMember').show();
        }    
        this.getUrl();
        
    },
    methods:{
        closePricingPop(val){
            this.showmodule=val;
            this.$emit('closePricingPop');
        },
        showPricingPop(){
            $('.photo_rights').hide();
            this.showmodule=true;
        },
        // 登录弹窗
        loginFn(){
            var user=utils.getCookie('user');
            if(!user){
                $('.maskMember').show();
            }else{
                user=JSON.parse(user)
                var data={
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    product_id:173
                }
                $('.photo_rights_load').addClass("show");
                $('.photo_rights').removeClass("show");
                this.$axios.post(utils.urlPost('account')+'benefit/status',data).then((res)=>{
                    try {
                        var subscriptions=res.data.subscriptions
                        var total=0;
                        var use=0;
                        for(var i=0;i<subscriptions.length;i++){
                            total+=subscriptions[i].benefits[4].quota*1
                            use+=subscriptions[i].benefits[4].usage*1
                        }
                        $('.photo_rights_load').removeClass("show");
                        $('.photo_rights').addClass('show');
                        // $('.photo_rights .num').html(total-use);
                        this.num=total-use;
                    } catch (error) {
                        
                    }
                    this.getUrl();
                    this.getCredits(user)
                })

                
                
            }
            
        },
        //获取点数权益
        getCredits(user){
            var dataCredits={
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token,
                product_id:179
            }
            this.$axios.post(utils.urlPost('account')+'benefit/status',dataCredits).then((res)=>{
                var subscriptions=res.data.subscriptions
                var total=0;
                var use=0;
                
                for(var i=0;i<subscriptions.length;i++){
                    for(var j=0;j<subscriptions[i].benefits.length;j++){
                        if(subscriptions[i].product_feature!='101'){
                            if(subscriptions[i].benefits[j].key == "credit"){
                                total+=parseInt(subscriptions[i].benefits[j].quota);
                                use+=parseInt(subscriptions[i].benefits[j].cost);
                            }
                        }
                    }
                }
                var credits = total-use;
                this.num = this.num + Math.floor(credits/2);
            })
        },
        // 获取跳转链接
        getUrl(){
            var self=this;
            var data={
                e_id:user.e_id,
                t_id:user.t_id,
                token:user.token,
                product_id:173
            }
            this.$axios.post(utils.urlPost('account')+'account/session/code',data).then((res)=>{
                var lang = utils.getLang();
                if(lang == "jp"){
                    lang="ja";
                }
                self.url=accountHref+"?code="+res.data.code+"&lang="+lang+"&murmur="+oldmurmur
            })
            // }
            
        },
        // history(){
        //     var user=utils.getCookie('user');
        //     console.log(user);
        //     if(user){
        //         window.open("https://account.aiseesoft.com/history-files?product=173");
        //     }else{
        //         $('.maskMember').show();
        //     }
        // },
    },
    watch:{
        showupgrade(val){
            this.showmodule=val;
        }
    },
}
</script>
<style lang="scss" scoped>
.show{display: block!important;}
.photo_rights_load,.photo_rights{display: none;width: 330px;background: #FFFFFF;box-shadow: 0px 6px 13px -4px rgba(0, 0, 0, 0.5);border-radius: 9px;position: absolute;top: 60px;right: 30px;z-index: 1000;padding: 0px 10px 0px 30px;box-sizing: border-box;}
.photo_rights_load,.photo_rights{padding:0 0 30px;}
.photo_rights_load .load{width: 60px;height: 60px; margin: 30px auto 20px;display: block;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;width: 60px;}
.photo_rights_load p{text-align: center;font-size: 16px;color: #333;}
/* photo_rights */
.photo_rights{padding: 20px;}
.photo_rights p{font-size: 18px;color: #333;}
.photo_rights p span,.photo_rights p .num{color: #2473E8;font-weight: bold;}
.photo_rights p .num{font-style: normal;}
.photo_rights p a{color: #2473E8;text-decoration: underline;}
.photo_rights .btn{width: 244px;height: 46px;line-height: 46px;font-size: 20px;font-weight: 600;color: #fff;background: #ff9602;border-radius: 26px;display: block;margin: auto;text-align: center;margin-top: 20px;cursor: pointer;font-weight: normal;}
.photo_rights .btn:hover{text-decoration: none;background: #f7aa3d;color: #fff;}
    .header{
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(166, 166, 166, 0.3);
        height: 56px;
        padding-left: 24px;
        padding-right: 24px;
        box-sizing: border-box;
        align-items: center;
        min-width: 1350px;
        .icon-icon{
                display: inline-block;
                width: 30px;
                height: 30px;
                color:#2473e8;
        }
        .icon-return{
            display: none;
        }
        .back_btn{
            text-decoration: none;
            font-weight: bold;
            &:hover{
                color:#2473E8;
            }
        }
        >.left{
            a{
                text-decoration: none;
                *{
                    vertical-align: middle;
                }
                // img{
                //     display: inline-block;
                //     margin-right: 18px;
                // }
            }
        }
        >.right{
            >span{
                margin-right: 20px;
                cursor: pointer;
                >*{vertical-align: middle;}
                >i{
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }
            }
            >span:last-child{
                margin-right: 0px;
            }
            .upgrde{
                .upgrade{
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                    // color:#FF4545;
                    // FF9431
                    // fill:"url(#paint0_linear_82_290)";
                    color: #FF613F;
                    &:hover{
                        color:#FF9E44;
                        // filter: drop-shadow(#FF9E44 10000px 0);
                        // transform: translateX(-10000px);
                    }
                }
                // background: url(../assets/upgrade.svg);
                // &:hover{
                //     background: url(../assets/upgrade-s.svg);
                // }
            }
            .history{
                .history-svg{
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                    color:#2473E8;
                    &:hover{
                        color:#3E8CFF;
                    }
                }
                // background: url(../assets/history.svg);
                // &:hover{
                //     background: url(../assets/history-s.svg);
                // }
            }
            .login{
                .login-svg{
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                    color:#2473E8;
                    &:hover{
                        color:#3E8CFF;
                    }
                }
                // background: url(../assets/login.svg);
                // &:hover{
                //     background: url(../assets/login-s.svg);
                // }
            }
        }
    }
    @media(max-width:1024px) and (min-width:480px) {
        .header{
            box-shadow: unset;
            padding-right: 0px;
            height: 72px;
            padding-left: 40px;
            min-width: 100%;
            .icon-return{
                display: inline-block;
            }
            .vertical{
                display: none;
            }
            .back_btn{
                display: none;
            }
            >.right{

                .upgrde {
                    display: none;
                }
                .history {
                    display: none;
                }
                >span{
                    margin-right: 40px;
                    cursor: pointer;
                    >*{vertical-align: middle;}
                    >i{
                        width: 24px;
                        height: 24px;
                        margin-right: 8px;
                    }
                }
            }
        }
    }
    @media(max-width:480px) {
        .header{
            box-shadow: unset;
            padding-right: 0px;
            height: 72px;
            min-width: 100%;
            .icon-return{
                display: inline-block;
            }
            .vertical{
                display: none;
            }
            .back_btn{
                display: none;
            }
            >.right{

                .upgrde {
                    display: none;
                }
                .history {
                    display: none;
                }
            }
        }
    }
</style>